import axios from "axios"
import React, { Component } from "react"
import { Button, Modal, Spinner } from "react-bootstrap"
import AxiosConfig from "../../../../utilities/AxiosConfig"
//@ts-ignore
import FileViewer from "react-file-viewer"
import "./DocViewer.css"
import snackBar from "../../../../utilities/snackBar/SnackBar"
import IconBuilder from "../../../../utilities/iconBuilder/IconBuilder"
import DocDownloader from "../DocDownloader/DocDownloader"

interface Props {
    fileName: string | null
    extension: string | null
    toggleDocViewer: Function
    displayName: string
    containerName: string
    storageLocation: string
}

interface State {
    file: any | null
    path: string | null
    extension: string | null
    name: string | null
    loadingFile: boolean
    download: boolean
}

class DocViewer extends Component<Props, State> {

    state = {
        file: null,
        path: "",
        extension: null,
        name: null,
        loadingFile: false,
        download: false
    }

    componentDidMount() {
        this.getDocument()
    }

    componentWillUnmount() {
        this.setState({
            file: null,
            path: "",
            extension: null,
            name: null,
            loadingFile: false,
        })
    }

    base64ToFile = (base64String: any) => {
        let str = atob(base64String)
        let i = str.length
        let u8arr = new Uint8Array(i)
        while (i--) {
            u8arr[i] = str.charCodeAt(i)
        }
        return new File([u8arr], "file-preview")
    }

    getDocument = () => {
        this.setState({ loadingFile: true })
        axios.get(process.env.REACT_APP_IMG_API_URL + `/api/file/get/${this.props.containerName}/${this.props.storageLocation}/${this.props.fileName}/`, AxiosConfig.configValue("min"))
            .then(res => {
                const file = this.base64ToFile(res.data);
                this.setState({ file: URL.createObjectURL(file), loadingFile: false })
            }).catch(err => {
                this.setState({ loadingFile: false })
                snackBar({ type: "error", text: "Failed to fetch file", timeout: 3000 })
                this.props.toggleDocViewer()
            })
    }

    toggleDownload = () => {
        this.setState({ download: !this.state.download })
    }

    render() {

        const state = this.state
        const props = this.props
        const file = state.file
        const extension = props.extension || ""

        // //console.log("state:", state)
        // //console.log("props:", props)

        return (
            <div className="DocViewer">
                <Modal id="doc-viewer-modal"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                    size="xl"
                >
                    <Modal.Header>
                        <div className="DocViewerModalHeader">
                            <IconBuilder
                                extension={extension}
                                size={64}
                            />
                            <p>{this.props.displayName}</p>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="DocViewerModalBody">
                            {file && <FileViewer
                                fileType={props.extension?.toLowerCase()}
                                filePath={file}
                                errorComponent={<div></div>}
                                onError={() => snackBar({ type: "error", text: "Failed to load file", timeout: 3000 })}
                            />}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="DocViewerModalFooter">
                            {state.loadingFile && <Spinner id="doc-viewer-modal-spinner" animation="border" />}
                            {file && <DocDownloader
                                file={file}
                                extension={extension}
                                fileName={props.fileName}
                                toggleDownload={this.toggleDownload}
                                displayName={props.displayName}
                            />}
                            <Button id="doc-viewer-modal-footer-back-btn" variant="secondary" onClick={() => props.toggleDocViewer()}>Back</Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default DocViewer